/* eslint-disable max-len */
import React from 'react';
import { Col, Divider, Row } from 'antd';
// import { PictureOutlined, VideoCameraOutlined } from '@ant-design/icons';
import Wrapper from './style';
import { SocialAccountCard } from '..';
import { socmedType } from '../../configs/socmedType';

const Description = (props) => {
  const { label, value, emptyText = '(empty)' } = props;
  return (
    <Row gutter={[4, 4]}>
      {label && (
        <Col
          span={24}
          className="font-paragraph_medium black3 description_label"
        >
          {label}
        </Col>
      )}
      <Col
        span={24}
        className={`font-paragraph ${
          value ? 'black1' : 'black4'
        } description_value`}
      >
        {value || emptyText}
      </Col>
    </Row>
  );
};

const Ad = (props) => {
  const { dataSource } = props;
  // const adSetupList = dataSource?.ad_media || [];
  const adData = dataSource?.data?.facebook_ad || {};
  const adPageData = adData?.page || {};
  const socialData = dataSource?.chooseAccount || {};
  const chooseAd = dataSource?.chooseAds || {};
  const primaryText = adData?.creative?.data?.ad_creative?.name;
  const callToAction =
    adData?.creative?.data?.ad_creative?.object_story_spec?.link_data
      ?.call_to_action?.type;
  const link =
    adData?.creative?.data?.ad_creative?.object_story_spec?.link_data?.link;
  return (
    <Wrapper>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Description
                label="Ad Name"
                value={adData?.name || adData?.ad_name}
              />
            </Col>
            <Col span={24}>
              <Description
                label="Social Platform"
                value={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <SocialAccountCard
                    username={adPageData?.name}
                    type={socmedType?.FB_ADS}
                    adsAccountID={socialData?.ad_account_id}
                    showAvatar={false}
                  />
                }
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Divider style={{ margin: 0 }} />
        </Col>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24} className="font-subtitle2_medium black1">
              Ad Setup
            </Col>
            <Col span={24}>
              <Row gutter={[4, 4]}>
                <Col span={24} className="font-paragraph_medium black3">
                  Format
                </Col>
                <Col span={24} className="font-paragraph black2">
                  Dynamic creative is enabled. Multiple ads will be
                  automatically generated using your individual creative assets.
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={[4, 4]}>
                <Col span={24} className="font-paragraph_medium black2">
                  {dataSource?.format?.label}
                </Col>
                <Col span={24} className="font-paragraph black3">
                  {dataSource?.format?.description}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Divider style={{ margin: 0 }} />
        </Col>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Row gutter={[4, 4]}>
                <Col span={24} className="font-subtitle2_medium black1">
                  Ad Creative
                </Col>
                <Col span={24} className="font-paragraph black2">
                  Select the media, text, and destination for your ad. You can
                  also customize your media and text for each placement.
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Description
                label="Website creative source (Optional)"
                value={dataSource?.website_creative_source}
                emptyText="None"
              />
            </Col>
            <Col span={24}>
              <Description
                label="Ad Set Spend Limits (Optional)"
                value={dataSource?.website_creative_source ? 'On' : 'Off'}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Divider style={{ margin: 0 }} />
        </Col>
        {/* <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Row gutter={[12, 12]}>
                <Col span={24} className="font-subtitle2_medium black1">
                  Campaign Code
                </Col>
                <Col span={24} className="font-caption black2">
                  Automatically generated by alphaveritas and added into your
                  ads media
                </Col>
              </Row>
            </Col>
            <Col>
              <Col className="component_ad_campaign_code_media">
                <Image src="https://images.pexels.com/photos/1092671/pexels-photo-1092671.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" />
              </Col>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Divider style={{ margin: 0 }} />
        </Col> */}
        {/* <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24} className="font-subtitle2_medium black1">
              Ad Setup
            </Col>
            <Col span={24}>
              <Row gutter={[24, 24]}>
                {adSetupList.map((item) => {
                  return (
                    <Col key={item?.uid}>
                      <Col className="component_ad_campaign_code_media">
                        <Row gutter={[12, 12]}>
                          <Col
                            span={24}
                            className="component_ad_campaign_code_media_display"
                          >
                            {item?.type === 'video' ? (
                              <video src={item?.url}>
                                <track kind="captions" src={item?.url} />
                              </video>
                            ) : (
                              <img src={item?.url} alt="thumb" />
                            )}
                          </Col>
                          <Col span={24}>
                            <Row gutter={12}>
                              <Col className="font-subtitle2">
                                {item?.type === 'video' ? (
                                  <VideoCameraOutlined />
                                ) : (
                                  <PictureOutlined />
                                )}
                              </Col>
                              <Col className="font-paragraph">{item?.size}</Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Divider style={{ margin: 0 }} />
        </Col> */}
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Row gutter={[12, 12]}>
                <Col span={24} className="font-subtitle2_medium black1">
                  Primary Text
                </Col>
                <Col span={24} className="font-caption black2">
                  {primaryText}
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Description
                label="Headline (Optional)"
                value={chooseAd?.headline}
                emptyText="-"
              />
            </Col>
            <Col span={24}>
              <Description
                label="Description (Optional)"
                value={chooseAd?.content}
                emptyText="-"
              />
            </Col>
            <Col span={24}>
              <Row gutter={16}>
                <Col span={12}>
                  <Description
                    label="Website URL"
                    value={
                      <span style={{ textTransform: 'none' }}>{link}</span>
                    }
                    emptyText="-"
                  />
                </Col>
                <Col span={12}>
                  <Description
                    label="Call to Action"
                    value={callToAction}
                    emptyText="-"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Divider style={{ margin: 0 }} />
        </Col>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Row gutter={[12, 12]}>
                <Col span={24} className="font-subtitle2_medium black1">
                  Tracking
                </Col>
                <Col span={24} className="font-caption black2">
                  Track event datasets that contain the conversions your ad
                  might motivate. The dataset that contains the conversion
                  selected for the ad account will be tracked by default.
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Description
                label="Website Events"
                value={dataSource?.website_events ? 'Enabled' : 'Disabled'}
              />
            </Col>
            <Col span={24}>
              <Description
                label="App Events"
                value={dataSource?.app_events}
                emptyText="None"
              />
            </Col>
            <Col span={24}>
              <Description
                label="Offline Events"
                value={dataSource?.offline_events}
                emptyText="None"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
};

export default Ad;
